// Display only: retain meaningful decimals in server amounts; never change payment inputs.
export function formatPaymentAmount(value) {
  if (value === null || value === undefined || value === '') return '--';
  const text = typeof value === 'number'
    ? (Number.isFinite(value) ? value.toFixed(4) : '')
    : String(value).trim();
  if (!/^-?\d+(?:\.\d+)?$/.test(text)) return '--';
  const [whole, fraction = ''] = text.split('.');
  const significant = fraction.replace(/0+$/, '');
  return significant ? `${whole}.${significant}` : (Number(whole) === 0 ? '0' : whole);
}
